import React, { useEffect, useRef, useState } from 'react';
import styles from '../../assets/scss/TermsAndConditions.module.scss';
import Logo from '../../assets/images/cropLogo.png';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { BaseURL } from '../../lib/api';

const TermsAndConditions = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const type = queryParams.get('type');
    const token = queryParams.get('token');
    const hasNavigatedRef = useRef(false);
    const [loading, setLoading] = useState(true);
    const [validInvite, setValidInvite] = useState(false);

    // useEffect(() => {
    //     const checkInviteStatus = async () => {
    //         try {
    //             const res = await axios.post(
    //                 `${BaseURL}/invite/checkStatus?token=${token}`,
    //                 {},
    //                 {
    //                     headers: {
    //                         token: token,
    //                     },
    //                 }
    //             );

    //             if (res.data.valid) {
    //                 setValidInvite(true);
    //             } else {
    //                 toast.error('Your invitation link is no longer valid. Please log in.');
    //                 navigate('/');
    //             }
    //         } catch (error) {
    //             toast.error('Invalid or expired token. Redirecting to login...');
    //             navigate('/');
    //         } finally {
    //             setLoading(false);
    //         }
    //     };

    //     if (token) {
    //         checkInviteStatus();
    //     } else {
    //         toast.error('Missing token. Redirecting to login...');
    //         navigate('/');
    //     }
    // }, [token, navigate]);
    useEffect(() => {
        const checkInviteStatus = async () => {
            try {
                const res = await axios.post(
                    `${BaseURL}/invite/checkStatus?token=${token}`,
                    {},
                    {
                        headers: {
                            token,
                        },
                    }
                );

                if (res.data.valid) {
                    setValidInvite(true);
                } else {
                    if (!hasNavigatedRef.current) {
                        hasNavigatedRef.current = true;
                        toast.error('Your invitation link is no longer valid. Please log in.');
                        navigate('/');
                    }
                }
            } catch (error) {
                if (!hasNavigatedRef.current) {
                    hasNavigatedRef.current = true;
                    toast.error('Invalid or expired token. Redirecting to login...');
                    navigate('/');
                }
            } finally {
                setLoading(false);
            }
        };

        if (token) {
            checkInviteStatus();
        } else {
            if (!hasNavigatedRef.current) {
                hasNavigatedRef.current = true;
                toast.error('Missing token. Redirecting to login...');
                navigate('/');
            }
        }
    }, [token, navigate]);

    const handleAccept = () => {
        navigate('/Profiles', {
            state: { type, token },
        });
    };

    const handleReject = () => {
        toast.info('You have rejected the Terms and Conditions.');
    };

    if (loading) {
        return <div className={styles.loading}>Checking invite link...</div>;
    }

    if (!validInvite) return null;

    return (
        <div className={styles.container}>
            <div className={styles.card}>
                <div className={styles.leftSection}>
                    <img src={Logo} alt="Logo" className={styles.logo} />
                </div>

                <div className={styles.rightSection}>
                    <h1 >Terms and Conditions of Website Use</h1>
                    <p><strong>Effective Date:</strong> {new Date().toLocaleDateString()}</p>

                    <ol>
                        <li><strong>Acceptance of Terms</strong><br />
                            By accessing or using CropWork ("Website"), you agree to be bound by these Terms and Conditions ("Terms"). If you do not agree with any part of the Terms, you must not use this Website.
                        </li>
                        <li><strong>Eligibility</strong><br />
                            You must be at least 18 years old to use this Website. By using the Website, you warrant that you are of legal age and have the authority to enter into these Terms.
                        </li>
                        <li><strong>User Accounts</strong><br />
                            To access certain features, you may be required to register an account.
                            <ul>
                                <li>You agree to provide accurate, current, and complete information during registration.</li>
                                <li>You are responsible for maintaining the confidentiality of your account credentials and for all activities under your account.</li>
                            </ul>
                        </li>
                        <li><strong>Use of the Website</strong><br />
                            You agree to use the Website only for lawful purposes, including browsing or engaging in transactions between farmers, wholesalers, and retailers.
                            <ul>
                                <li>Post false, misleading, or fraudulent content</li>
                                <li>Violate any laws or third-party rights</li>
                                <li>Distribute spam or harmful software</li>
                                <li>Interfere with the website’s operations or security</li>
                            </ul>
                        </li>
                        <li><strong>Intellectual Property</strong><br />
                            All content on this Website, including text, images, logos, and software, is the property of CropWork or its licensors and is protected by copyright and other intellectual property laws. You may not copy, reproduce, or distribute any part of the Website without permission.
                        </li>
                        <li><strong>Purchases and Transactions</strong><br />
                            If you engage in transactions on this Website (e.g., placing orders, invoicing, or billing), you agree to provide accurate information and abide by all applicable policies, including payment and refund terms.
                        </li>
                        <li><strong>Termination</strong><br />
                            We reserve the right to suspend or terminate your account and access to the Website at our discretion, without notice, if you violate these Terms.
                        </li>
                        <li><strong>Limitation of Liability</strong><br />
                            We are not liable for any indirect, incidental, or consequential damages arising from your use of the Website. We do not guarantee the accuracy or reliability of information provided by other users.
                        </li>
                        <li><strong>Changes to Terms</strong><br />
                            We may update these Terms at any time. Changes will be posted on this page with an updated effective date. Continued use of the Website constitutes acceptance of the revised Terms.
                        </li>
                        <li><strong>Governing Law</strong><br />
                            These Terms are governed by and construed in accordance with the laws of India - Tamil Nadu, without regard to its conflict of law principles.
                        </li>
                    </ol>

                    <p><strong>Contact Us:</strong> If you have any questions about these Terms, please contact us at <a href="mailto:Admin@cropwork.in">Admin@cropwork.in</a></p>

                    <div className={styles.footerButtons}>
                        <button className={styles.cancelButton} onClick={handleReject}>Reject</button>
                        <button className={styles.primaryButton} onClick={handleAccept}>Accept</button>
                    </div>

                </div>
            </div>
        </div>
    );
};

export default TermsAndConditions;
